import React from 'react';
import Typography from '@mui/material/Typography';
import dialogStyles from '../../common/dialogStyles';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';

interface DeleteDhcpReservationFormProps {
  reservationIp: string;
  reservationMac: string;
  reservationDescription: string;
}

const DeleteDhcpReservationForm: React.FC<DeleteDhcpReservationFormProps> = ({
  reservationIp,
  reservationMac,
  reservationDescription,
}) => {
  return (
    <DialogContent sx={dialogStyles.dialogContentForm}>
      <DialogContent>
        <Stack spacing={1.5} alignItems="center">
          <Stack direction="row" spacing={1}>
            <Typography fontWeight="bold">MAC address:</Typography>
            <Typography>{reservationMac}</Typography>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Typography fontWeight="bold">IP address:</Typography>
            <Typography>{reservationIp}</Typography>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Typography fontWeight="bold">Description:</Typography>
            <Typography>{reservationDescription}</Typography>
          </Stack>
        </Stack>
      </DialogContent>
    </DialogContent>
  );
};

export default DeleteDhcpReservationForm;
